<div class="px-2 my-2 ">
  <h1 class="">Tasks</h1>
  <div class="mt-5 md:px-5">
    <div class=" mb-2 border-grey-500 border-[1px] rounded-md p-3">
      <div class="flex justify-between  hover:cursor-pointer" (click)="changeAuditSearchDisplay()">
        <div class="flex">
          <p class="text-lg">{{ 'audit' | customerTerm:true }}</p>
          @if (!ShowAuditSearch) {
            <span class="material-symbols-outlined cursor-pointer pr-2 text-xl ml-2"
            >edit</span>
          }
        </div>

        @if (!ShowAuditSearch) {
          <p class="font-bold">{{SelectedAuditType.Description}} -
          {{SelectedAudit.AuditName}}</p>
        }
      </div>

      @if (ShowAuditSearch) {
        <div>
          <div class="flex-col flex lg:flex-row justify-between">
            <select class="text-box w-full md:max-w-xl mt-2 mx-2 standardTextSize"
              [(ngModel)]="SelectedAuditType" (change)="updateAudits()">
              @for (at of AuditTypes; track at) {
                <option [ngValue]="at">{{at.Description}}</option>
              }
            </select>
            <select class="text-box w-full md:max-w-xl mt-2 mx-2 standardTextSize" [(ngModel)]="SelectedAudit">
              @for (a of FilteredAudits ; track a) {
                <option [ngValue]="a">{{a.AuditName}}</option>
              }
            </select>
          </div>
        </div>
      }
    </div>
    <div class=" mb-2 border-grey-500 border-[1px] rounded-md p-3 ">
      <div class="flex justify-between hover:cursor-pointer" (click)="changeLocationSearchDisplay()">
        <div class="flex">
          <p class="text-lg ">Locations</p>
          @if (!ShowLocationSearch) {
            <span class="material-symbols-outlined cursor-pointer pr-2 text-xl ml-2"
            >edit</span>
          }
        </div>

        @if (!ShowLocationSearch) {
          <p class="font-bold">{{SelectedLocation.LocationName}}</p>
        }
      </div>

      @if (ShowLocationSearch) {
        <div class="flex-col ">
          <div class="flex-col flex lg:flex-row justify-between">
            <select class="text-box  mt-2 mx-2" [(ngModel)]="SelectedLocation">
              @for (a of FilteredLocations; track a) {
                <option [ngValue]="a">
                {{a.LocationName}}</option>
              }
            </select>
            <input type="text" class="text-box w-full  lg:mx-0 mt-2 mx-2" [(ngModel)]="LocationSearch"
              placeholder="Location Search" (keyup)="doLocationSearch()" />
            </div>
            <div class="mt-2">
              <div class="flex justify-start  items-center mt-4 lg:mt-0 lg:ml-4">
                <p>Include Sublocations:</p><app-toggle-switch [(checked)]="IncludeSublocations"
              class="ml-2"></app-toggle-switch>
            </div>
          </div>
        </div>
      }

    </div>
    <div class=" mb-2 border-grey-500 border-[1px] rounded-md p-3 ">
      <div class="flex justify-between hover:cursor-pointer" (click)="changeFrequencySearchDisplay()">
        <div class="flex">
          <p class="text-lg ">Frequency</p>
          @if (!ShowFrequencySearch) {
            <span class="material-symbols-outlined cursor-pointer pr-2 text-xl ml-2"
            >edit</span>
          }
        </div>

        @if (!ShowFrequencySearch) {
          <p class="font-bold">{{SelectedFrequency.Description}}</p>
        }
      </div>


      @if (ShowFrequencySearch) {
        <select class="text-box w-full md:max-w-xl mx-2 lg:mx-0 mt-2 standardTextSize"
          [(ngModel)]="SelectedFrequency" (change)="updateAudits()">
          @for (f of Frequencies; track f) {
            <option [ngValue]="f">{{f.Description}}</option>
          }
        </select>
      }
    </div>
    <div class=" mb-2 py-3">
      <div class="mt-4 flex flex-col  ">


        <button class="btn-primary w-full mt-3 text-xl "
          [ngClass]="{'hover:cursor-not-allowed':DisableFetchButton,'hover:cursor-pointer':!DisableFetchButton}"
          (click)="getTasks()" [disabled]="DisableFetchButton">@if (DisableFetchButton) {
          <span>Fetching
          Tasks...</span>
          }@if (!DisableFetchButton) {
          <span>Get Tasks</span>
        }
      </button>
      <div class="flex justify-center">
        @if (NoValidAudit) {
          <p class="text-danger-base mt-2">No {{ 'audit' | customerTerm:true | lowercase }} available for the given frequency and
          type.</p>
        }
      </div>

      <div class="flex flex-col lg:flex-row lg:justify-end">
        @if (TasksLoaded) {
          <div class="flex justify-start  items-center mt-4 self-end mr-4">
            <p>Show Incomplete Only:</p><app-toggle-switch (checkedChange)="updateCompleteOnly($event)"
          [(checked)]="ShowIncompleteOnly" class="ml-2"></app-toggle-switch>
        </div>
      }
      @if (TasksLoaded) {
        <div class="flex justify-start  items-center mt-4 self-end">
          <p>Show Complete Only:</p><app-toggle-switch (checkedChange)="updateIncompleteOnly($event)"
        [(checked)]="ShowCompleteOnly" class="ml-2"></app-toggle-switch>
      </div>
    }
  </div>

</div>

</div>
@if (TasksLoaded) {
  <div>
    @for (t of DisplayList; track t) {
      <div class=" ">
        <app-task-detail [task]="t" [LocalAudits]="getAllLocalAudits(t)"></app-task-detail>
      </div>
    }
  </div>
}
</div>
</div>
